import React, { useEffect, useRef, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

// Drapeaux dessinés en SVG (les emoji-drapeaux ne s'affichent pas sous Windows).
const BeninFlag = ({ className }) => (
  <svg viewBox="0 0 30 20" className={className} aria-hidden="true">
    <rect width="12" height="20" fill="#008751" />
    <rect x="12" width="18" height="10" fill="#FCD116" />
    <rect x="12" y="10" width="18" height="10" fill="#E8112D" />
  </svg>
);

export const COUNTRIES = [
  { code: 'Benin', label: 'Bénin', Flag: BeninFlag },
];

const flagCls = 'w-6 h-4 rounded-[3px] shadow-sm ring-1 ring-black/5 shrink-0';

const CountrySelect = ({ value, onChange, placeholder = 'Sélectionnez un pays', className = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = COUNTRIES.find((c) => c.code === value) || null;

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-3 bg-gray-100 rounded-lg px-4 py-3 text-left text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-custom"
      >
        {selected ? (
          <>
            <selected.Flag className={flagCls} />
            <span className="font-medium">{selected.label}</span>
          </>
        ) : (
          <span className="text-gray-500">{placeholder}</span>
        )}
        <FaChevronDown className={`ml-auto w-3 h-3 text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-50">
          {COUNTRIES.map((c) => (
            <button
              key={c.code}
              type="button"
              disabled={c.disabled}
              onClick={() => { if (c.disabled) return; onChange(c.code); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-left transition-colors ${
                c.disabled ? 'opacity-50 cursor-not-allowed' : c.code === value ? 'bg-gray-100' : 'hover:bg-gray-50'
              }`}
            >
              <c.Flag className={flagCls} />
              <span className="font-medium text-gray-900">{c.label}{c.disabled ? ' (bientôt)' : ''}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySelect;
